module.exports = __webpack_public_path__ + "bdb08eee2857c5a1a7f1c7416125a4b5.png";